module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d75b98aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/btn-toolbar.vue
// module id = 719
// module chunks = 85